import { VISA_FORCE_OPEN_STORAGE_KEY } from '../config';
import type { VisaFlowVariant } from '../types';

/**
 * Значения release-флага раздела. Оба «включённых» варианта показывают точки
 * входа и различаются тем, кто ведёт сбор: бот в диалоге или шаги на странице.
 */
export const VISA_CHAT_FLOW_VARIANT = 'visa_on';
export const VISA_WIZARD_FLOW_VARIANT = 'wizard_on';

interface ResolveVisaFlowVariantInput {
  /** Флаг отдал `visa_on`. */
  isChatFlow: boolean;
  /** Флаг отдал `wizard_on`. */
  isWizardFlow: boolean;
  /** DEV-обход флага; учитывается только когда флаг не отдал вариант. */
  forcedVariant?: VisaFlowVariant | null;
}

/**
 * Вариант флоу по ответу эксперимента. `null` — раздел выключен: точки входа
 * скрыты, но роуты остаются рабочими по прямому URL. `wizard_on` проверяется
 * первым, чтобы резолв был однозначным, если оба гейта истинны разом.
 */
export const resolveVisaFlowVariant = ({
  isChatFlow,
  isWizardFlow,
  forcedVariant = null,
}: ResolveVisaFlowVariantInput): VisaFlowVariant | null => {
  if (isWizardFlow) {
    return 'wizard';
  }

  if (isChatFlow) {
    return 'chat';
  }

  return forcedVariant;
};

/**
 * DEV-обход флага: легаси-значение `1` и `chat` открывают чат-вариант,
 * `wizard` — шаги без чата. В проде вариант форсит оверрайд дебаг-бара внутри
 * `checkExperimentVariant`, сюда он не доходит.
 */
export const readForcedVisaFlowVariant = (): VisaFlowVariant | null => {
  try {
    const stored = localStorage.getItem(VISA_FORCE_OPEN_STORAGE_KEY);

    if (stored === 'wizard') {
      return 'wizard';
    }

    return stored === '1' || stored === 'chat' ? 'chat' : null;
  } catch {
    return null;
  }
};
